import * as classes from "../css/text-section-with-image-on-right-physiolymp.module.css";
import frameTriangle   from "../images/designelement-bilderrahmen-dreieck.svg";
import triangleLarge   from "../images/erhalte-deine-beweglichkeit-dreieck groß.svg";
import triangleSmall   from "../images/erhalte-deine-beweglichkeit-dreieck-klein.svg";
import beweglichkeit   from "../images/anregung-zur-beweglichkeit.jpg";
import { transition }  from "./util/transition";
import React from "react";
import { useInView } from "react-intersection-observer";

export default function Osteopathie(): React.ReactElement {
  const { ref, inView } = useInView({
    threshold: 0.2,
    rootMargin: "400px 0px -400px 0px",
    initialInView: true,
  });

  return (
    <section className={classes.section} ref={ref}>
      <div className="skew-y-10 transform bg-gray-200 mt-72 md:mt-56 pt-20 xl:pt-0 pb-96 -mb-72 text-black">
        <div className="-skew-y-4 transform pb-10">
          <div className="max-w-screen-2xl m-auto px-6 md:px-14 relative">
            <span id="osteopathie" style={{ position: "relative", top: "-21rem" }} />
            <img height="10" src={frameTriangle} alt="Anregung zur Selbstheilung Bild"
                 className={classes.frameTriangle}
                 style={{
                   transition: transition(inView, 0),
                   transform: `translate(50%, ${inView ? "0" : "-1rem"})`,
                   opacity: inView ? 1 : 0,
                 }} />
            <img aria-hidden="true" height="10" src={triangleLarge} alt=""
                 className={classes.largeTriangle}
                 style={{
                   transition: transition(inView, 150),
                   transform: `translate(0, ${inView ? "0" : "-1rem"})`,
                   opacity: inView ? 1 : 0,
                 }} />
            <img aria-hidden="true" height="10" src={triangleSmall} alt=""
                 className={classes.smallTriangle}
                 style={{
                   transition: transition(inView, 300),
                   transform: `translate(0, ${inView ? "0" : "-1rem"})`,
                   opacity: inView ? 1 : 0,
                 }} />
            <div
              aria-label="Anregung zur Beweglichkeit"
              className={classes.image}
              style={
                {
                  "--background": `url(${beweglichkeit})`,
                  transition: transition(inView, 150),
                  transform: `translate(var(--translation-x), calc(${
                    inView ? "0px" : "-1rem"
                  } + var(--translation-y)))`,
                  opacity: inView ? 1 : 0,
                } as never
              }
            />
            <div className="text-right md:text-left">
              <span className={classes.subtitle} style={{
                transition: transition(inView, 450),
                transform: `translateY(${inView ? "0" : "-1rem"})`,
                opacity: inView ? 1 : 0,
              }}>Anregung zur</span>{" "}
              <span className={classes.title} style={{
                transition: transition(inView, 550),
                transform: `translateY(${inView ? "0" : "-1rem"})`,
                opacity: inView ? 1 : 0,
              }}>Selbstheilung</span>
            </div>

            <div className={`md:ml-5 xl:mt-16 pt-2 ${classes.content}`} style={{
              transition: transition(inView, 850),
              transform: `translateY(${inView ? "0" : "-1rem"})`,
              opacity: inView ? 1 : 0,
            }}>
              <h2 className="pt-4 uppercase pb-3 font-light text-yellow-600" style={{ fontSize: "2.15rem" }}>
                Osteopathie
              </h2>
              <p className={classes.content}>
                Wir schauen nicht einfach nur auf Symptome, sondern arbeiten gemeinsam an der <b>Ursache</b> Deiner Probleme…
              </p>
            </div>
          </div>
        </div>
      </div>

    </section>
  );
}
